export default __webpack_public_path__ + "static/media/add-point-speeding.930729a5.svg";